<div class="flex w-full gap-2 text-sm justify-center py-2 pr-1 pl-2" [formGroup]="form">
  <span>Комитеты:</span>
  <mat-checkbox class="com-committee-one-checkbox" [formControlName]="EventTypeIds.committee"> 1.0</mat-checkbox>
  <mat-checkbox class="com-committee-two-checkbox" [formControlName]="EventTypeIds.committee2_0"> 2.0</mat-checkbox>
</div>
